export default __webpack_public_path__ + "images/8ac8550d672a9597e1ab12d91c490791-orchestra_small.webp";